import {
  MAX_LENGTH_OF_ADD_JOB_INPUT,
  MIN_LENGTH_OF_ADD_JOB_SEARCH,
} from '../constants/globalFormValues';

const validations = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  tel: /^\+?\(?\d+(\)+\s?)?\d+(((-\d+)*)?((\.\d+)*)?((,\d+)*)?((\s\d+)*)?)*$/,
  number: /^-?\d+$/,
  alphanumeric: /^([a-zA-Z0-9 _!~@^&*()></-]+)$/, // forbidden characters: [#, $, %, ?]
  text: /^([a-zA-Z0-9 _!~@^&*()></-]+)$/,
}

export const isValidValue = (value, control, type, minLength, maxLength) => {
  const isInput = ['text', 'alphanumeric'].includes(control) && ['input', 'search', 'textarea'].includes(type);

  // Set error if the length od input is over the allowed maximum
  if (isInput && maxLength && value && value.trim().length > MAX_LENGTH_OF_ADD_JOB_INPUT) return false;

  // Set error if the length od input is under the required minimum
  if (isInput && minLength && value && value.trim().length < MIN_LENGTH_OF_ADD_JOB_SEARCH) return false;

  // For all other inputs, check if value is present
  if (isInput && value) return value.trim();

  return validations[control] && value ? validations[control].test(value) : true;
}



// WEBPACK FOOTER //
// ./src/utils/validations.js